import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-dark/10 via-black to-black pointer-events-none" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-95">
            El próximo lunes puedes seguir improvisando...
            <br data-id="element-96" />
            <span className="text-gold-gradient" data-id="element-97">
              O puedes entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-dark-card p-8 rounded-2xl border border-dark-border" data-id="element-98">
            {['Sin más noches buscando cómo explicar HACCP o microbiología con un lenguaje que tus alumnos entiendan', 'Sin más clases armadas de apuro con materiales pensados para otro nivel o para otro país', 'Sin más alumnos desconectados que no ven la relación entre la bromatología y su vida y su trabajo', 'Sin más fines de semana perdidos construyendo fichas técnicas y evaluaciones desde cero', 'Sin más silencios incómodos cuando un alumno pregunta algo sobre contaminantes, ETA o normativa que no tienes resuelto'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                <span className="text-gold mt-1" data-id="element-100">▸</span>
                <span className="text-gray-300" data-id="element-101">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-102">
            El Mega Pack Bromatología en el Aula no te convierte en mejor
            docente.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-103">
            Vos ya eres un buen docente.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-104">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase.
          </p>
        </div>

        <div className="bg-black border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-105">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-dark-border pb-6" data-id="element-106">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107">
            {['Tomo 1 — Fundamentos y composición de alimentos', 'Tomo 2 — Microbiología alimentaria aplicada', 'Tomo 3 — Calidad, inocuidad, BPM y HACCP', 'Tomo 4 — Análisis, contaminantes y conservación', 'Bono 1 — Paquete de actividades listas para usar', 'Bono 2 — Paquete de evaluaciones completas', 'Bono 3 — Recetarios técnicos para el taller escolar', 'Bono 4 — Criterios de corrección y banco de respuestas', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                <Check size={18} className="text-gold shrink-0" data-id="element-109" />
                <span className="text-sm text-gray-200" data-id="element-110">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111">
            <div className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-112">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" />
              <span className="text-gold font-bold not-italic" data-id="element-114">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-115">
              🧪 Mega Pack Bromatología en el Aula
            </p>
            <p className="text-sm text-gray-400 mb-8" data-id="element-116">
              Hecho por especialistas, para docentes técnicos de todo el mundo
              hispanohablante.
            </p>

            <Button href="#pricing" className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-118">
              <span data-id="element-119">✅ Garantía de 7 días</span>
              <span data-id="element-120">✅ Pago seguro</span>
              <span data-id="element-121">✅ Acceso inmediato</span>
              <span data-id="element-122">✅ Pagas en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}